import React, { useEffect } from 'react'
import { CFormInput, CFormLabel, CFormText, CFormTextarea } from '@coreui/react'

const CustomDescriptionBox = ({
  title = '',
  placeholder = '',
  isMandatory = false,
  errorText = '',
  rows,
  limit = 500,
  value,
  onChange,
  disabled = false,
  style = {},
  limitFontSize = '',
  useFormInput = false,
}) => {
  const handleValueChange = (newVal) => {
    onChange(newVal.substring(0, limit))
  }

  useEffect(() => {
    console.log(value)
    onChange(value.substring(0, limit))
  }, [limit])

  return (
    <div>
      {title && <CFormLabel>{title}</CFormLabel>}
      {useFormInput ? (
        <CFormInput
          placeholder={placeholder}
          onChange={(event) => handleValueChange(event.target.value)}
          value={value}
          disabled={disabled}
          style={style}
        />
      ) : (
        <CFormTextarea
          placeholder={placeholder}
          rows={rows}
          onChange={(event) => handleValueChange(event.target.value)}
          value={value}
          disabled={disabled}
          style={style}
        />
      )}

      <div className={`d-flex ${isMandatory ? 'justify-content-between' : 'justify-content-end'} `}>
        <div className="message-text error-message">
          <p>{isMandatory && value?.length === 0 ? errorText : ''}</p>
        </div>
        <CFormText
          style={{ color: value.length < limit ? 'black' : 'red', fontSize: limitFontSize }}
        >
          Characters : {value.length}/{limit}
        </CFormText>
      </div>
    </div>
  )
}

export default CustomDescriptionBox
